module.exports = __webpack_public_path__ + "img/symbol_12.e7a5e2cf.png";